import type { ChatAttachmentView } from "web_myplann/Chat/Types/chatMessage";

export const getChatAttachmentKey = (
	attachment: ChatAttachmentView,
	index: number,
) => attachment.localUrl ?? attachment.id ?? `attachment-${index}`;
